/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { Authorization } from './Authorization';
import type { IsoAddress } from './IsoAddress';
import type { LegalEntityIdentifiers } from './LegalEntityIdentifiers';
import type { MoneyAmount } from './MoneyAmount';
import type { PayeeVerificationResult } from './PayeeVerificationResult';
import type { PaymentSymbol } from './PaymentSymbol';
import type { Receiver } from './Receiver';
import type { SignInfo } from './SignInfo';
import type { StandingOrderCosigningState } from './StandingOrderCosigningState';
import type { StandingOrderExecution } from './StandingOrderExecution';
import type { StandingOrderLinks } from './StandingOrderLinks';
import type { StandingOrderType } from './StandingOrderType';
import type { StandingOrderValidity } from './StandingOrderValidity';

export type StandingOrder = {
    /**
     * External identifier of standing order (as described in WebApi specification).
     */
    externalId: string;
    /**
     * External account identifier (as described in WebApi specification).
     */
    externalAccountId: string;
    type: StandingOrderType;
    /**
     * Standing order subtype.
     */
    subtype?: StandingOrder.subtype;
    /**
     * Standing order status.
     */
    status: StandingOrder.status;
    cosigningState?: StandingOrderCosigningState;
    amount: MoneyAmount;
    /**
     * Minimum allowed transaction amount for sweep order.
     */
    minAmount?: MoneyAmount;
    execution: StandingOrderExecution;
    validity?: StandingOrderValidity;
    /**
     * User defined name for the standing order.
     */
    alias?: string;
    /**
     * Set first not null of attributes in this priority: alias, receiver name, receiver iban, receiver account number, receiver bank code.
     */
    title: string;
    /**
     * Set first not null of the following attributes in this priority: paymentReference, senderReference. Field is needed by mobile clients (iOS, Android)
     */
    subtitle?: string;
    receiver: Receiver;
    receiverAddress?: IsoAddress;
    /**
     * Identifies payment order on receiver side.
     */
    paymentReference?: string;
    /**
     * Identifies payment order on sender side.
     */
    senderReference?: string;
    /**
     * The intended purpose for the payment order.
     */
    intendedPurpose?: string;
    /**
     * Message for payment order reciever.
     */
    messageForRecipient?: string;
    /**
     * Payment order identifier.
     */
    orderId?: string;
    /**
     * Payment order description.
     */
    text?: string;
    paymentSymbol?: PaymentSymbol;
    flags?: Array<'EDITABLE' | 'DELETABLE' | 'CANCELABLE' | 'COLLECTIVE_SIGNING' | 'POCKET_MONEY' | 'VISIBLE_FOR_RECIPIENT' | 'STOP_REGULAR_EXECUTIONS_AFTER_DEATH'>;
    /**
     * Payment reference for Croatian and Serbian domestic payments.
     */
    reference?: {
        /**
         * *In Croatia*: Reference number. *In Serbia*: Model.
         */
        number: string;
        /**
         * *In Croatia*: Additional information corresponding to reference number. Mandatory, if reference number other than 99. *In Serbia*: Reference number.
         */
        description?: string;
    };
    signInfo?: SignInfo;
    authorizations?: Array<Authorization>;
    legalEntityIdentifiers?: LegalEntityIdentifiers;
    payeeVerificationResult?: PayeeVerificationResult;
    /**
     * Payment purpose code
     */
    purposeCode?: string;
    _links: StandingOrderLinks;
};

export namespace StandingOrder {

    /**
     * Standing order subtype.
     */
    export enum subtype {
        SWEEP_OVER_LIMIT = 'SWEEP_OVER_LIMIT',
        SWEEP_UNDER_LIMIT = 'SWEEP_UNDER_LIMIT',
    }

    /**
     * Standing order status.
     */
    export enum status {
        OK = 'OK',
        NEXT_EXECUTION_DATE_AUTOMATICALLY_SET = 'NEXT_EXECUTION_DATE_AUTOMATICALLY_SET',
        NOT_CHANGEABLE = 'NOT_CHANGEABLE',
        ADVISOR_CHANGEABLE = 'ADVISOR_CHANGEABLE',
        IN_EXECUTION = 'IN_EXECUTION',
        DELETED = 'DELETED',
        CREATE_STANDING_ORDER_PENDING = 'CREATE_STANDING_ORDER_PENDING',
        EDIT_STANDING_ORDER_PENDING = 'EDIT_STANDING_ORDER_PENDING',
        DELETE_STANDING_ORDER_PENDING = 'DELETE_STANDING_ORDER_PENDING',
    }


}

